<template>
    <div class="vx-col md:w-full sm:w-auto" v-if="userInfo.userRole == 'user'">
        <div class="vx-row md:w-full">
            <vx-tooltip class="position-icon" :text="$t('button.call')" position="top">
                <feather-icon icon="PhoneIcon" class="action-success icon-btn"
                              svgClasses="h-5 w-5 cursor-pointer"
                              @click.stop="callBack"/>
            </vx-tooltip>
            <vx-tooltip class="position-icon" :text="$t('button.message')" position="top" v-if="rowData.customer[0].user">
                <feather-icon icon="MessageCircleIcon" class="action-success icon-btn"
                              svgClasses="h-5 w-5 cursor-pointer"
                              @click.stop=""/>
            </vx-tooltip>
            <vx-tooltip class="position-icon" :text="$t('button.remainer')" position="top">
                <feather-icon icon="ClockIcon" class="action-success icon-btn"
                              svgClasses="h-5 w-5 cursor-pointer"
                              @click.stop="showCallHistoryPopup(rowData.id)"/>
            </vx-tooltip>
        </div>
        <vs-popup class="holamundo" title="Hẹn lại lịch sử cuộc gọi" :active.sync="showCallHistory">
            <div class="mb-2">
                <label class="vs-input--label">Tiêu đề</label>
                <vs-input class="w-full" v-model="title" name="title"/>
            </div>
            <div class="mb-2">
                <label class="vs-input--label">Nội dung</label>
                <vs-textarea class="w-full" v-model="content"/>
            </div>
            <div class="mb-2">
                <vs-radio v-model="type" vs-value="1" class="mr-4" vs-name="layout-type-vertical">Sau khoảng thời gian
                </vs-radio>
                <vs-radio v-model="type" vs-value="2" class="mr-4" vs-name="layout-type-vertical">Thời gian cụ thể
                </vs-radio>
            </div>
            <div class="mb-2" v-if="this.type == '1'">
                <label class="vs-input--label">Nhập số phút</label>
                <vs-input class="w-full" type="number" v-model="time" name="time"/>
            </div>
            <div class="mb-2" v-else>
                <label class="vs-input--label">Nhập thời gian</label>
                <datepicker class="vdp-datepicker__calendar-fixed" v-model="dateTime" :language="vi" :format="'dd/MM/yyyy'"></datepicker>
            </div>
            <div class="mt-4">
                <div class="flex float-right">
                    <vs-button color="primary" @click="saveCallHistory" class="mr-4">Lưu</vs-button>
                    <vs-button color="danger" @click="showCallHistory = false" type="border">Đóng</vs-button>
                </div>
            </div>
        </vs-popup>
    </div>
</template>

<script>
import {en, vi} from "vuejs-datepicker/dist/locale";
import Datepicker from 'vuejs-datepicker';
export default {
    name: "CellRendererActions",
    props: {
        rowData: {
            type: Object,
            required: true,
        },
    },
    components: {
        Datepicker
    },
    data() {
        return {
            userInfo: JSON.parse(localStorage.getItem('userInfo')),
            showCallHistory: false,
            title: null,
            content:null,
            type:1,
            time:15,
            callHistoryID: null,
            dateTime: new Date(),
            en: en,
            vi: vi,
        }
    },
    methods: {
        css(){
            document.getElementById('css').checked = true;
        },
        callBack() {
            let payload = {}
            payload.phoneNumber = this.rowData.customer[0].phone
            this.$eventBus.$emit("beauty-call", payload);
        },
        showCallHistoryPopup(id){
            this.type = 1
            this.showCallHistory = true
            this.callHistoryID = id
        },
        saveCallHistory(){
            const data = {
                title: this.title,
                content:this.content,
                type:this.type,
                time: this.type == '1' ? this.time : null,
                dateTime: this.type == '2' ? this.time : null,
                callHistoryId: this.callHistoryID
            }
            // console.log('data', data)
            // return 0
            if (!this.title || !this.content ||  !this.time || !this.dateTime){
                return this.$vs.notify({
                    text: 'Vui lòng nhập đầy đủ thông tin!',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'warning',
                });
            }
            this.$vs.loading();
            this.$crm.post('/ott/remind-call-history/create', data).then(res => {
                this.$vs.notify({
                    text: 'Hẹn lịch sử cuộc gọi thành công!',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                });
                this.showCallHistory = false
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Error',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        }
    }
}
</script>

<style>
    .vdp-datepicker__calendar-fixed .vdp-datepicker__calendar{position: fixed}
</style>
